import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteIgvFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='IGV' htmlFor='input-importeIgv' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber id='input-importeIgv' name='input-importeIgv' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteIgvFormGroup)
